/* istanbul ignore file */

const problemOptions = [
  {
    label: 'o produto veio danificado ou com defeito',
    value: 'BROKEN_PRODUCT',
  },
  {
    label: 'recebi o produto errado',
    value: 'WRONG_PRODUCT',
  },
  {
    label: 'o produto veio incompleto',
    value: 'INCOMPLETE_PRODUCT',
  },
  {
    label: 'o produto não é original',
    value: 'FAKE_PRODUCT',
  },
  {
    label: 'o produto é diferente da descrição ou foto',
    value: 'DIFFERENT_PRODUCT',
  },
  {
    label: 'outro',
    value: 'OTHER',
  },
];

const troubleOptionsMetric = (key: string) => {
  let label = '';

  switch (key) {
    case 'BROKEN_PRODUCT':
      label = 'produto-danificado';
      break;
    case 'WRONG_PRODUCT':
      label = 'produto-errado';
      break;
    case 'INCOMPLETE_PRODUCT':
      label = 'produto-incompleto';
      break;
    case 'FAKE_PRODUCT':
      label = 'produto-nao-e-original';
      break;
    case 'DIFFERENT_PRODUCT':
      label = 'produto-diferente';
      break;
    case 'OTHER':
      label = 'outro-problema';
      break;
    default:
      console.error('troubleOptionsMetric receive key incorrect');
      break;
  }
  return label;
};

export { problemOptions, troubleOptionsMetric };
